module.exports = __webpack_public_path__ + "static/media/linux.98ee3666.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/linux.svg
// module id = 63
// module chunks = 0